import { Badge } from '@/components/ui/badge';
import type { ShippingStatus } from '../types';

interface ShippingStatusBadgeProps {
  status: ShippingStatus;
  className?: string;
}

const statusConfig: Record<
  ShippingStatus,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }
> = {
  to_prepare: { label: 'To Prepare', variant: 'outline' },
  in_preparation: { label: 'In Preparation', variant: 'secondary' },
  ready: { label: 'Ready', variant: 'default' },
  verified: { label: 'Verified', variant: 'default' },
  shipped: { label: 'Shipped', variant: 'secondary' },
  received: { label: 'Received', variant: 'default' },
};

const statusColors: Record<ShippingStatus, string> = {
  to_prepare: 'bg-gray-100 text-gray-800 border-gray-300',
  in_preparation: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  ready: 'bg-blue-100 text-blue-800 border-blue-300',
  verified: 'bg-purple-100 text-purple-800 border-purple-300',
  shipped: 'bg-orange-100 text-orange-800 border-orange-300',
  received: 'bg-green-100 text-green-800 border-green-300',
};

export function ShippingStatusBadge({ status, className }: ShippingStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, variant: 'outline' as const };
  const colorClass = statusColors[status] || 'bg-gray-100 text-gray-800 border-gray-300';

  return (
    <Badge variant="outline" className={`${colorClass} ${className || ''}`}>
      {config.label}
    </Badge>
  );
}
